var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opacity"},[_c('b',[_vm._v(_vm._s(_vm.strong))]),_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" (das genaue Splittingszenario finden Sie "),_c('a',{attrs:{"href":"https://wie-gross-wird-der-bundestag.de/expertinnentool"}},[_vm._v("hier")]),_vm._v("). "),_c('span',[_vm._v(_vm._s(_vm.praedikat))])])
}
var staticRenderFns = []

export { render, staticRenderFns }